module.exports = __webpack_public_path__ + "img/magnifying-glass-zoom.e623fe25.svg";